module.exports = __webpack_public_path__ + "static/media/thumbs-up.9cc0657b.png";